import { Component, OnInit } from '@angular/core';

import { OptionProperty } from '../../types/control.types';
import { OptionsControlBaseComponent } from '../../controls/options-control-base/options-control-base.component';
import { AbstractPropertyEditorBase } from '../../types/property-editor.types';
import { OptionItem } from '../../types/control.types';
import { AbstractValueControlBase } from '../../types/abstract-value-control-base';
import { ValueControlViewModel } from '../../types';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'lib-default-value-property-editor',
  templateUrl: './default-value-property-editor.component.html',
  styleUrls: ['./default-value-property-editor.component.css']
})
export class DefaultValuePropertyEditorComponent extends AbstractPropertyEditorBase implements OnInit {
  tabsData: Array<OptionProperty>;
  choice?: number = 0;

  set tabValue(val: any) {
    this._tabValue = val;
    this.memberSetting.disabled = !this._tabValue;
  }
  get tabValue(): any {
    return this._tabValue;
  }

  memberSetting = { maxlength: 50, reg: /^[A-Za-z]+[A-Za-z0-9]*$/, disabled: true };

  displayMember: string;
  valueMember: string;

  control: AbstractValueControlBase<ValueControlViewModel<any>>;

  private _tabValue: string;

  constructor() {
    super();
  }

  ngOnInit() {}

  get showSetMember(): boolean {
    return this.choice === 1;
  }

  selectedItem(event: any) {
    this.tabsData.forEach((item: OptionProperty, index) => {
      if (event.id === item.id) {
        item.selected = true;
        this.choice = index;
        this.tabValue = item.value;
        this.displayMember = item.displayMember;
        this.valueMember = item.valueMember;
      } else {
        item.selected = false;
      }
    });
  }

  afterControlValueInit() {
    this.tabsData = this.value;
    this.defaultSelection();
  }

  defaultSelection() {
    if (!this.tabsData) {
      this.tabsData = [
        { text: 'èªå®ä¹', id: 'custom', selected: true, value: '' },
        { text: 'æ°æ®æº', id: 'dataSource', selected: false, value: '' }
      ];
    }

    // å¼å®¹èçæ¬é»è®¤å¼è®¾ç½®æ¹å¼
    if (this.tabsData) {
      const custom = this.tabsData.find((s) => s.id === 'custom');
      if (custom) {
        custom.value = custom.value || this.control.model.value;
      }
    }

    this.selectedItem(this.tabsData.filter((s: OptionProperty) => s.selected === true)[0]);
    this.setTabValue();
  }

  setTabValue() {
    // è®¾ç½®æ°æ®
    this.tabsData[this.choice].value = this.tabValue;
    this.tabsData[this.choice].displayMember = this.displayMember;
    this.tabsData[this.choice].valueMember = this.valueMember;
    this.afterSetControlValue(this.tabsData);
    this.control.defaultValueChange();
  }
}
